"use client";

import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import { ErrorPageProps } from "@/lib/error-page-props";
import { NavButton } from "@/components/nav-button";
import StatusContainer from "@/components/containers/status-container";
import { Logo } from "@/components/logo";
import { getRedirectInfo } from "@/lib/utils";
import { FlexContainer } from "@/components/containers/flex-container";

export const runtime = "edge";

export default function ErrorPage({}: ErrorPageProps) {
  const pathname = usePathname();
  const redirectInfo = getRedirectInfo(pathname);

  const t = useTranslations("Error");

  return (
    <div className="flex h-full flex-col md:gap-4">
      <div>
        <div className="flex justify-center align-middle">
          <div className="mx-auto">
            <Logo />
          </div>{" "}
        </div>
      </div>
      <FlexContainer variant="status-main" component="main">
        <StatusContainer
          title={t("title")}
          heading={t("heading")}
          desc={t("desc")}
          button={
            <NavButton href={redirectInfo.url} sticky>
              {t(redirectInfo.label)}
            </NavButton>
          }
        />
      </FlexContainer>
    </div>
  );
}
